import { Box, BoxProps, Typography } from '@mui/material';
import { mergeSx } from '../../utils/styles';
import { Participant } from '../../@types';
import useBreakpoints from '../../hooks/useBreakpoints';
import ParticipantAsset from '../atoms/ParticipantAsset';

type EventCardParticipantProps = {
  competitionName?: string | null;
  logoPlacement?: 'inline' | 'top';
  participant: Participant;
  sportId?: string | null;
  sx?: BoxProps['sx'];
};

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    minWidth: 0,
  },
  topRoot: {
    flexDirection: { xs: 'row', md: 'column' },
    justifyContent: { xs: 'flex-start', md: 'center' },
    gap: 0.5,
    textAlign: { xs: 'left', md: 'center' },
  },
  mobileTopRoot: {
    width: 1,
    maxWidth: '100%',
  },
  participantName: {
    minWidth: 0,
    maxWidth: '100%',
  },
  mobileTopParticipantName: {
    width: 1,
  },
};

const EventCardParticipant = ({
  competitionName,
  logoPlacement = 'inline',
  participant,
  sportId,
  sx,
}: EventCardParticipantProps) => {
  const { isMobile } = useBreakpoints();
  const jerseySize = isMobile ? 20 : 28;
  const isLogoAboveName = logoPlacement === 'top';
  const shouldConstrainMobileTopName = isMobile && isLogoAboveName;

  return (
    <Box
      sx={mergeSx(
        styles.root,
        sx,
        isLogoAboveName && styles.topRoot,
        shouldConstrainMobileTopName && styles.mobileTopRoot
      )}
    >
      <ParticipantAsset
        competitionName={competitionName}
        jersey={participant.jersey}
        participantId={participant.id}
        participantName={participant.name}
        size={jerseySize}
        sportId={sportId}
      />
      <Typography
        noWrap={isMobile || !isLogoAboveName}
        variant='body2'
        title={participant.name}
        sx={mergeSx(
          {
            fontWeight: 600,
          },
          mergeSx(styles.participantName, shouldConstrainMobileTopName && styles.mobileTopParticipantName)
        )}
      >
        {participant.name}
      </Typography>
    </Box>
  );
};

export default EventCardParticipant;
